import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { authClient } from "../../lib/auth-client";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    await authClient.requestPasswordReset({ email, redirectTo: `${window.location.origin}/reset-password` });
    setSubmitting(false);
    // Always show the same confirmation, whether or not the address exists —
    // never reveal account existence via response differences.
    setSent(true);
  }

  return (
    <div className="pw-centered-page">
      <div className="pw-centered-page__panel pw-card">
        <h1 style={{ margin: "0 0 0.3rem", fontSize: "1.4rem", fontWeight: 600 }}>Passwort zurücksetzen</h1>
        {sent ? (
          <p style={{ fontSize: "0.9rem", color: "var(--pw-color-text-body)" }}>
            Wenn diese E-Mail-Adresse zu einem Konto gehört, wurde ein Link zum Zurücksetzen versendet.
          </p>
        ) : (
          <form onSubmit={(e) => void onSubmit(e)} noValidate>
            <div className="pw-field">
              <label htmlFor="email">E-Mail</label>
              <input id="email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <button type="submit" className="pw-button pw-button--primary" disabled={submitting} style={{ width: "100%" }}>
              {submitting ? "Wird gesendet …" : "Link senden"}
            </button>
          </form>
        )}
        <p style={{ margin: "1rem 0 0", fontSize: "0.8rem", textAlign: "center" }}>
          <Link to="/login">Zurück zur Anmeldung</Link>
        </p>
      </div>
    </div>
  );
}
